import { faLock } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormInput } from '../FormInput/FormInput.js';

class FormPassword extends FormInput {
    getInputProps(fieldProps) {
        return {
            ...super.getInputProps(fieldProps),
            type: "password"
        };
    }
}
FormPassword.defaultProps = {
    prepend: /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faLock
    }),
    autoComplete: "password"
};

export { FormPassword };
//# sourceMappingURL=FormPassword.js.map
